<section class="px-[4%] sm:px-[9.3%] py-8 lg:py-12 3xl:py-16">
  <div class="flex flex-col gap-6 lg:gap-0 lg:flex-row items-center justify-between mb-7 3xl:mb-8">
    <h2
      class="self-start text-3xl sm:text-4xl 3xl:text-5xl lg-leading-[40px] 3xl:leading-[57.6px] font-semibold 3xl:font-bold text-dark-gray2">
      Latest News & Insights</h2>
    <div class="self-end flex items-center gap-4 3xl:gap-6">
      <app-button [routerLink]="'/news-&-insights'" [size]="'medium'" heading="See more"
        icon="assets/shared/r-arrow.svg"></app-button>
      <div [className]="progress.abs == 0 ? 'pointer-events-none opacity-[0.6]':''">
        <app-button size="medium" (click)="prevSlide()" icon="assets/shared/l-arrow.svg"></app-button>
      </div>
      <div [className]="progress.abs == progress.maxIdx ? 'pointer-events-none opacity-[0.6]':''">
        <app-button size="medium" (click)="nextSlide()" icon="assets/shared/r-arrow.svg"></app-button>
      </div>
    </div>
  </div>
  <div class="keen-slider" #sliderRef>
    <div class="keen-slider__slide" *ngFor="let blog of blogs">
      <app-news-card [imageUrl]="blog.imgUrl" [date]="blog.date" [title]="blog.title"
        [tags]="blog.tags" [navigate] = "blog.link"></app-news-card>
    </div>
  </div>
</section>